import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe, NgComponentOutlet } from '@angular/common';
import { CurrencyPipe } from '@shared/pipes/currency/currency.pipe';
import { DataAttributeDirective } from '@shared/directives/data-attribute.directive';
import { EmptyPipe } from '@shared/pipes/empty/empty.pipe';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { UserBalanceInfoBaseComponent } from '../../../../base/user-balance-info-base/user-balance-info-base.component';
import { UiModule } from '@ui/ui.module';
import { PopoverModule } from 'primeng/popover';
import { Popover } from 'primeng/popover';
import { ShowOnPlatformNarrowDirective } from '@shared/directives/show-on-platform-narrow.directive';
import { PlatformService } from '@services/utils/platform.service';
import { Button } from 'primeng/button';

@Component({
  selector: 'b2b-user-balance-info',
  imports: [
    CurrencyPipe,
    AsyncPipe,
    DataAttributeDirective,
    EmptyPipe,
    RouterLink,
    TranslocoPipe,
    NgComponentOutlet,
    UiModule,
    PopoverModule,
    ShowOnPlatformNarrowDirective,
    Button,
  ],
  templateUrl: './user-balance-info.component.html',
  styleUrl: './user-balance-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserBalanceInfoComponent extends UserBalanceInfoBaseComponent {
  private readonly platformService = inject(PlatformService);

  public onBalanceDetailsClick(event: Event, balanceDetailsPopover: Popover): void {
    if (this.platformService.isMobile()) {
      void this.openBalanceDetailsDialog();
      return;
    }

    void this.showBalanceDetails(event, balanceDetailsPopover);
  }
}
